import { useTranslation } from 'react-i18next'

import { Card, CardTitle, Divider } from '@reveni-io/reveni-ui'

import ReturnProtectionInfo from '@/common/components/ReturnProtectionInfo/ReturnProtectionInfo'

import ExceptionInfo from './ExceptionInfo/ExceptionInfo'
import PolicyRulesApplied from './PolicyRulesApplied/PolicyRulesApplied'
import * as Styles from './styles'

const AppliedActionsCard = ({ allowList, policyRules, isCoveredByReturnProtection }) => {
  const { t } = useTranslation()
  const hasPolicyRules = policyRules?.length > 0

  if (!allowList && !hasPolicyRules && !isCoveredByReturnProtection) {
    return null
  }

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Acciones aplicadas')}</CardTitle>
      <Styles.MainContainer>
        {isCoveredByReturnProtection && (
          <ReturnProtectionInfo
            message={t('Este método de devolución está cubierto por tu contrato de Return Protection')}
          />
        )}
        {isCoveredByReturnProtection && (allowList || hasPolicyRules) && <Divider />}
        {allowList && <ExceptionInfo exception={allowList} policyRules={policyRules} />}
        {allowList && hasPolicyRules && <Divider />}
        <PolicyRulesApplied policyRules={policyRules} disabledPolicyRuleId={allowList?.policy_rule_id} />
      </Styles.MainContainer>
    </Card>
  )
}

export default AppliedActionsCard
